import {type ForestMassStatus, STATUS_FINSA} from '@/domain/entities/ForestMassStatus';

class BusinessLogicBasedOnStatuses {
  constructor(readonly statuses: ForestMassStatus) {}
  isForestMassCut(): boolean {
    return (
      this.statuses.finsaStatus === STATUS_FINSA.CUT_FORCED ||
      this.statuses.finsaStatus === STATUS_FINSA.WEIGHT_PENDING ||
      this.statuses.finsaStatus === STATUS_FINSA.CUT_WEIGHTED
    );
  }
}

export default BusinessLogicBasedOnStatuses;
